module.exports = __webpack_public_path__ + "static/media/full-screen-image-3.a319a340.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/full-screen-image-3.jpg
// module id = 2111
// module chunks = 0